import { GET_NOTIFICATIONS } from "../actions/types";

const initialState={}
export default function notifications(state = initialState, action) {
    switch (action.type) {
      case GET_NOTIFICATIONS:
        return action.payload;
      default:
        return state;
    }
  }